module.exports = __webpack_public_path__ + "fonts/SuisseIntl-UltralightItalic.f57e4c8.woff";